import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useTitle } from "@/hooks/use-title";

export default function PrivacyPage() {
  useTitle("Privacy Policy");
  return (
    <div className="min-h-screen bg-black text-white p-8">
      <div className="max-w-4xl mx-auto space-y-8">
        <Card className="bg-zinc-900 border-zinc-800">
          <CardHeader>
            <CardTitle>Privacy Policy</CardTitle>
            <CardDescription>
              Last updated: January 30, 2025
            </CardDescription>
          </CardHeader>
          <CardContent className="prose prose-invert">
            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">Overview</h2>
              <p>
                This privacy policy describes how we collect, use, and protect your
                personal information when you use our platform.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">Information We Collect</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Email address (for authentication)</li>
                <li>Display name (optional)</li>
                <li>YouTube membership status (if connected)</li>
                <li>Profile picture (optional)</li>
                <li>Watch history and preferences</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">How We Use Your Information</h2>
              <p>We use your information to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Provide and improve our services</li>
                <li>Personalize your experience</li>
                <li>Verify YouTube channel membership</li>
                <li>Send important updates about our service</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">Data Protection</h2>
              <p>
                We implement industry-standard security measures to protect your
                personal information. Your data is stored securely and is only
                accessed when necessary to provide our services.
              </p>
            </section>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}